<template>
  <div>
    <form-template :references.sync="formReferences" :model="modelObj" ref="documentBuilderFormRef">
      <template slot="extraDetails">
        <sharepoint-report-builder-treeview v-if="!dataLoading" v-model="documents" :traverseNodes="modelObj.traversenodeids"
          ref="sharepointDocumentBuilderRef"></sharepoint-report-builder-treeview>
      </template>
    </form-template>
    <v-dialog v-model="showFirstPageContentDialog" persistent max-width="1000px" class="mt-0">
      <v-card>
        <v-card-title class="pa-1">
          {{ $t('message.document.firstPageContent') }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-1">
          <ckeditor v-if="showEditor" :editor="editor" v-model="ckEditorContentModel" :config="configEditor"></ckeditor>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-layout class="d-flex justify-center">
            <v-btn color="warning" class="mx-1" @click="ckEditorContentModel = ''">{{ $t('message.user.clear') }}</v-btn>
            <v-btn color="primary" class="mx-1" @click="modelObj.firstpagecontent = ckEditorContentModel;showFirstPageContentDialog=false;showEditor=false">{{ $t('message.common.ok') }}</v-btn>
            <v-btn color="error" class="mx-1" @click="showFirstPageContentDialog=false;showEditor=false">{{ $t('message.common.close') }}</v-btn>
            <!-- <v-btn color="error" class="mx-1" @click="showFirstPageContentDialog=false;showEditor=false">{{ $t('message.common.close') }}</v-btn> -->
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
/* eslint-disable vue/no-side-effects-in-computed-properties */
import { mapGetters } from 'vuex'
import FormTemplate from '@/components/FormTemplate'
import documentTemplateMixin from '@/views/Documents/templateMixin'
import Editor from '@/ckeditor'
export default {
  mixins: [documentTemplateMixin],
  data () {
    return {
      modelObj: {
        id: Number(this.$route.params.report_id) || 0,
        traversenodeids: {},
        firstpagecontent: ''
      },
      MODULE: 'documentreports',
      documents: [],
      loading: false,
      dataLoading: true,
      showFirstPageContentDialog: false,
      editor: Editor,
      configEditor: {
        height: 450,
        toolbar: {
          removeItems: ['insertTable']
        }
      },
      showEditor: false,
      ckEditorContentModel: ''
    }
  },
  components: {
    FormTemplate,
    SharepointReportBuilderTreeview: () => import('@/components/Documents/SharepointTreeViewForReport.vue')
  },
  computed: {
    ...mapGetters(['formType']),
    formReferences () {
      return {
        title: this.modelObj.id ? `${this.$t('message.document.updateReport')}` : `${this.$t('message.document.addReport')}`,
        showActionsOnHeader: true,
        hideActionsOnFooter: true,
        properties: [{
          model: 'title',
          type: this.formType.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.deviations.title'),
          class: 'xs12 sm6 md4 lg3'
        }, {
          model: 'onlyformodules',
          type: this.formType.SELECT,
          rules: [],
          items: this.documentTemplateModules,
          select_text: 'text',
          select_value: 'value',
          label: this.$t('message.document.module'),
          class: 'xs12 sm6 md4 lg3',
          multiple: true,
          showSelectAll: true
        }, {
          model: 'description',
          type: this.formType.TEXTAREA,
          rules: [],
          label: this.$t('message.customer.description'),
          class: 'xs12 sm6 md4 lg4',
          rows: 3
        }],
        buttons: [{
          name: 'add_firstpage_content',
          color: 'primary',
          label: this.$t('message.document.firstPageContent'),
          click: () => {
            this.ckEditorContentModel = this.modelObj.firstpagecontent
            this.showFirstPageContentDialog = true
            setTimeout(() => {
              this.showEditor = true
            }, 150)
          },
          is_show: true
        }, {
          name: 'action_handler',
          color: 'success',
          label: this.modelObj.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: this.saveUpdateHandler,
          loading: this.loading,
          is_show: true
        }, {
          name: 'backtolist',
          color: 'error',
          click: () => this.$router.push('/document_builder').catch(() => {}),
          label: this.$t('message.common.backToList'),
          is_show: true
        }]
      }
    }
  },
  mounted () {
    if (this.modelObj.id) this.getSingleRecordHandler(this.modelObj.id)
    else this.dataLoading = false
  },
  methods: {
    getSingleRecordHandler (id) {
      this.dataLoading = true
      this.$_getSingleRecordHandler(`${this.MODULE}/${id}`)
        .then(({ data }) => {
          data.onlyformodules = data.onlyformodules ? JSON.parse(data.onlyformodules) : []
          data.traversenodeids = typeof data.traversenodeids === 'string' ? JSON.parse(data.traversenodeids) : {}
          data.documents = data.documents ? JSON.parse(data.documents) : []
          this.documents = data.documents
          this.modelObj = data
        }).finally(() => {
          this.dataLoading = false
        })
    },
    saveUpdateHandler () {
      if (this.$refs.documentBuilderFormRef.$refs.validateForm.validate()) {
        this.loading = true
        const model = this.modelObj
        if (model.onlyformodules) model.onlyformodules = JSON.stringify(model.onlyformodules)
        if (this.documents) {
          if (this.$refs.sharepointDocumentBuilderRef && this.$refs.sharepointDocumentBuilderRef.traverseTracker) {
            const traverseTracker = this.$refs.sharepointDocumentBuilderRef.traverseTracker
            model.traversenodeids = (traverseTracker && this.documents.length) ? traverseTracker : {}
          }
          model.documents = JSON.stringify(this.documents)
        }
        model.traversenodeids = JSON.stringify(model.traversenodeids)
        const url = this.MODULE
        this.$_saveUpdateHandler(url, model)
          .then((response) => {
            this.$router.push('/document_builder')
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
  }
}
</script>
